import { format } from "date-fns";
import PropTypes from "prop-types";

import Button from "@shared/v2/Button";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";

import { STYLES } from "../shared";

const formatName = (name) => {
  if (name === "null null") return "No Name";

  const parts = name.split(" ");

  return parts.at(-1) === "null" ? parts.slice(0, -1).join(" ") : name;
};

const Header = ({ category, personName, time, onReadChange, loading, read }) => {
  const isPlace = useTheme().name === "place-theme";

  return (
    <div className="tw-flex tw-items-center tw-w-full">
      <div className="tw-flex tw-gap-12px tw-items-center tw-flex-wrap">
        {category}
        <span className="tw-text-14d tw-font-semibold">{formatName(personName)}</span>
      </div>
      <div className="tw-h-28px tw-flex tw-gap-16px tw-justify-end tw-items-center tw-ml-auto tw-relative">
        <div className="tw-flex tw-gap-16px tw-items-center group-hover:tw-hidden">
          <span className="tw-text-12d tw-text-gray-50">{format(`${time}`, "hh:mm aaa")}</span>
          <div
            className={`tw-block tw-rounded-full tw-w-8px tw-h-8px tw-ml-auto ${STYLES.bgThemed(isPlace)} ${read ? "tw-hidden" : ""}`}
          />
        </div>
        <Button
          disabled={loading}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onReadChange();
          }}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          type="button"
          size="small"
          schema="secondary"
          className={`tw-bg-white !tw-absolute tw-whitespace-nowrap ${read ? "tw-w-[114px]" : "tw-w-[97px]"} tw-hidden group-hover:tw-block`}
        >
          {`Mark as ${read ? "unread" : "read"}`}
        </Button>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  loading: PropTypes.bool,
  category: PropTypes.node.isRequired,
  time: PropTypes.string.isRequired,
  onReadChange: PropTypes.func.isRequired,
  personName: PropTypes.string.isRequired,
  read: PropTypes.bool,
};

Header.defaultProps = {
  loading: false,
  read: false,
};
